import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const ButtonWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  gap: theme.spacing(2),

  [theme.breakpoints.down('sm')]: {
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
}));
